<template>
  <v-container fluid grid-list-md py1>
    <v-layout row wrap>
      <v-flex md4>
        <v-card>
          <v-card-title primary-title class="py-2">
            <v-toolbar-title>{{ $t("view.operativos.vendor.title") }}</v-toolbar-title>
            <v-spacer />
            <v-btn icon @click="view.elem.showForm = !view.elem.showForm">
              <v-icon>{{ view.elem.showForm ? "keyboard_arrow_down" : "keyboard_arrow_up" }}</v-icon>
            </v-btn>
          </v-card-title>
          <v-expand-transition>
            <v-flex v-show="view.elem.showForm" class="py-0">
              <v-card-text>
                <form onSubmit="return false;" @submit="submit" @keyup.ctrl.83="executeValidators">
                  <!-- Clave -->
                  <v-text-field v-if="vendor.clave" v-model="vendor.clave" :label="$t('view.commons.clave')" disabled />

                  <!-- Descripcion -->
                  <v-text-field
                    v-model.trim="$v.vendor.descripcion.$model"
                    :label="$t('view.operativos.vendor.form.descripcion.label')"
                    :error-messages="getFirstErrorDescription($v.vendor.descripcion)"
                    maxlength="50"
                    :disabled="view.action.submit.busy"
                    onkeypress="return /^[a-zA-Z0-9\r\.\+\-\_\ ]+$/.test(event.key);" />

                  <!-- Canales -->
                  <v-flex md12>
                    <v-autocomplete
                      v-model.trim="$v.vendor.canales.$model"
                      :label="$t('view.operativos.vendor.form.canales.label')"
                      :error-messages="getFirstErrorDescription($v.vendor.canales)"
                      :items="view.elem.select.canales.filteredList"
                      :disabled="view.action.submit.busy || view.elem.select.canales.disabled"
                      item-value="code"
                      item-text="name"
                      hide-selected
                      deletable-chips
                      clearable
                      multiple
                      small-chips
                      :no-data-text="$t('view.commons.nodata')"
                      @input="search = ''" />
                  </v-flex>

                  <!-- Rep -->
                  <v-flex md12>
                    <v-autocomplete
                      v-model.trim="$v.vendor.rep.$model"
                      :label="$t('view.operativos.vendor.form.rep.label')"
                      :error-messages="getFirstErrorDescription($v.vendor.rep)"
                      :items="view.elem.select.rep.filteredList"
                      :disabled="view.action.submit.busy || view.elem.select.rep.disabled"
                      item-value="code"
                      item-text="name"
                      hide-selected
                      return-object
                      deletable-chips
                      clearable
                      multiple
                      small-chips
                      :no-data-text="$t('view.commons.nodata')"
                      @input="search = ''" />
                  </v-flex>

                  <!-- Emails -->
                  <v-autocomplete
                    v-model.trim="$v.vendor.email.$model"
                    :label="$t('view.operativos.vendor.form.email.label')"
                    :items="view.elem.select.email.filteredList"
                    :disabled="view.action.submit.busy"
                    :search-input.sync="email"
                    hide-selected
                    hide-no-data
                    deletable-chips
                    clearable
                    multiple
                    small-chips
                    prepend-icon="fas fa-plus-circle"
                    @click:prepend="addEmail"
                    @keydown="addEmailKey" />

                  <!-- Emails facturacion -->
                  <v-autocomplete
                    v-model.trim="$v.vendor.emailFacturacion.$model"
                    :label="$t('view.operativos.vendor.form.mailFacturacion.label')"
                    :disabled="view.action.submit.busy"
                    :search-input.sync="emailFacturacion"
                    :items="view.elem.select.emailFacturacion.filteredList"
                    hide-selected
                    hide-no-data
                    deletable-chips
                    clearable
                    multiple
                    small-chips
                    prepend-icon="fas fa-plus-circle"
                    @click:prepend="addEmailFacturacion"
                    @keydown="addEmailKey" />

                  <!-- Estatus -->
                  <label for="status" class="v-label mt-3">{{ $t("view.commons.status") }}</label>
                  <v-switch v-model="vendor.status" input-value="true" color="primary" :disabled="view.action.submit.busy" />
                </form>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-flex shrink>
                  <v-btn
                    v-show="vendor.clave && $userPermission.hasPermission('ROLE_ACCESO_AUDITORIA')"
                    id="btnaudit"
                    fab
                    small
                    color="primary"
                    class="btn_tippy"
                    elevation="0"
                    :title="$t('view.commons.audit')"
                    :loading="view.action.submit.busy"
                    @click="audit()">
                    <v-icon small>storage</v-icon>
                  </v-btn>

                  <v-btn id="btnclear" fab small color="primary" class="btn_tippy" elevation="0" :title="$t('view.commons.cancel')" :loading="view.action.submit.busy" @click="clear()">
                    <v-icon small>fa-eraser</v-icon>
                  </v-btn>

                  <v-btn
                    v-show="$userPermission.hasPermission('ROLE_MODIFICAR_OP')"
                    id="btnsubmit"
                    fab
                    small
                    color="primary"
                    class="btn_tippy"
                    elevation="0"
                    :title="view.elem.button.submit.title.current"
                    :loading="view.action.submit.busy"
                    :disabled="form.$state.isDisableButtonSubmit()"
                    @click="submit()">
                    <v-icon small>{{ view.elem.button.submit.class.current }}</v-icon>
                  </v-btn>
                </v-flex>
              </v-card-actions>
            </v-flex>
          </v-expand-transition>
        </v-card>
      </v-flex>

      <v-flex md8>
        <data-table ref="vendorTable" @editRow="load" @auditRow="audit" />
      </v-flex>
    </v-layout>
    <auditoria ref="auditModal" />
  </v-container>
</template>
<script>
import vendorStates from "@/views/operativos/vendor/vendor-state"; /** *******************************/
import vendorAPI from "@/services/operativos/vendor"; /** *******************************/
import DataTable from "@/views/operativos/vendor/DataTable"; /** *******************************/
import Auditoria from "@/components/auditoria/Auditoria"; /** *******************************/
import { EventBus } from "@/events/event-bus";
import * as events from "@/constants/event-names";
import { required } from "vuelidate/lib/validators";
import { fixMigImp } from "@/helpers/vuelidate/validators";
import { allValidatorMethods } from "@/helpers/vuelidate";
import { handleResponse } from "@/helpers/http-response-handler";
import { scrollToForm } from "@/helpers/form-scroll-to";
import { CANALES_SELECT } from "@/constants/operativos";
import { submit } from "@/constants/buttons";
import tippy from "tippy.js";

const select = {
  canales: {
    filteredList: CANALES_SELECT
    , disabled: false
  }
  , rep: {
    completeList: []
    , filteredList: []
    , disabled: false
  }
  , email: { filteredList: [] }
  , emailFacturacion: { filteredList: [] }
};

const action = { submit: { busy: false } };

export default {
  name: "VendorModule"
  , components: {
    DataTable
    , Auditoria
  }
  , data() {
    return {
      vendor: undefined
      , form: new Object()
      , email: ""
      , emailFacturacion: ""
      , view: {
        title: this.$t("view.operativos.vendor.title")
        , action
        , elem: {
          button: { submit }
          , select
          , showForm: true
        }
      }
      , check: true
    };
  }
  , head: {
    title: function () {
      return {
        inner: this.view.title
        , separator: "|"
        , complement: this.$t("view.commons.system")
      };
    }
  }
  , created() {
    this.form = new vendorStates(this);
    this.form.$setState("initial");
  }
  , updated() {
    this.$nextTick(function () {
      tippy(".btn_tippy", { arrow: true, arrowType: "round", animation: "scale" });
    });
  }
  , methods: {
    ...allValidatorMethods
    , async submit() {
      try {
        const respuesta = await this.form.$state.submit(this.vendor);
        handleResponse(respuesta, this.$t("view.operativos.vendor.errors"));
      } catch (error) {
        handleResponse(error, this.$t("view.operativos.vendor.errors"));
      }
    }
    , async load(clave) {
      try {
        await this.form.$state.loadSelectsData();
        const response = await vendorAPI.get(clave);
        const { data: { results: { vendor } } } = response;
        this.form.$setState("editing", vendor);
      } catch (error) {
        console.log(error);
      }
    }
    , async clear() {
      await this.form.$state.askForClear();
      setTimeout(() => document.body.click(), 300);
    }
    , async audit(clave = this.vendor.clave, dataDescripcion = this.vendor.descripcion) {
      this.$refs.auditModal.loadAudit(clave, "TVendor", dataDescripcion, this.view.title);
    }
    , executeValidators() {
      if (!this.isAllValid(this.$v)) {
        EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", this.$t("errors.validof"));
        scrollToForm(this);
      }
    }
    , addEmailKey(key) {
      if (key && key.keyCode == 13) this.addEmail();
    }
    , addEmail() {
      if (this.email != null && this.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email)) {
        this.executeValidators();
      }
      if (this.email != null && this.email && this.email != "" && (this.vendor.email == null || !this.vendor.email.includes(this.email)) && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email)) {
        if (this.vendor.email == null) {
          this.vendor.email = [];
        }
        this.vendor.email.push(this.email);
        this.view.elem.select.email.filteredList.push(this.email);
        this.email = null;
      }
    }
    , addEmailFacturacion() {
      if (this.emailFacturacion != null && this.emailFacturacion && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.emailFacturacion)) {
        this.executeValidators();
      }
      if (this.emailFacturacion != null && this.emailFacturacion && this.emailFacturacion != "" && (this.vendor.emailFacturacion == null || !this.vendor.emailFacturacion.includes(this.emailFacturacion)) && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.emailFacturacion)) {
        if (this.vendor.emailFacturacion == null) {
          this.vendor.emailFacturacion = [];
        }
        this.vendor.emailFacturacion.push(this.emailFacturacion);
        this.view.elem.select.emailFacturacion.filteredList.push(this.emailFacturacion);
        this.emailFacturacion = null;
      }
    }
  }
  , validations: {
    vendor: {
      descripcion: { required, fixMigImp: fixMigImp() }
      , canales: { required }
      , rep: {}
      , email: {}
      , emailFacturacion: {}
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/operativos/vendor/Vendor.vue